<template>
  <v-container fluid>
    <v-app-bar
      app
      color="primary"
      dark
      extension-height="64"
    >
      <v-row>
        <v-col cols="4" class="py-0">
          <v-text-field prepend-icon="mdi-magnify" v-model="baseSearchInput" @keyup="onSearchChange"
                        hide-details></v-text-field>
        </v-col>
        <v-col cols="4" class="py-0">
          <div class="text-center">
            <v-pagination
              v-model="page"
              :length="Math.ceil(basesFiltered.length / pageSize)"
              :total-visible="7"
            ></v-pagination>
          </div>
        </v-col>
        <v-col cols="4" class="py-0" align="right">
          <v-btn icon :color="expanded ? 'green' : 'white'" @click="expanded = !expanded">
            <v-icon>mdi-filter</v-icon>
          </v-btn>
          <div v-if="saving">
            <v-progress-circular color="green" indeterminate></v-progress-circular>
            Saving
          </div>
        </v-col>
      </v-row>
      <template v-slot:extension v-if="expanded">
        <v-row>
          <v-col cols="1" class="pt-5">
            Filters:
          </v-col>
          <v-col cols="3">
            <v-select label="Difficulty" :items="difficulties" v-model="filter.difficulty" hide-details/>
          </v-col>
          <v-col cols="3">
            <strong>Days of wipe:</strong>
            <v-btn-toggle
              color="green"
              v-model="filter.daysOfWipe"
              multiple
            >
              <v-btn small v-for="day in days" :key="day">
                {{ day }}
              </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-col cols="3" class="pt-5">
            <v-checkbox label="Autospawn Enabled" v-model="filter.autospawnEnabled" @change="save(base)"
                        hide-details></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-btn @click="clearFilter()">Clear Filters</v-btn>
          </v-col>
        </v-row>
      </template>
    </v-app-bar>
    <v-row>
      <v-col
        v-for="(base, index) in basesPage"
        :key="index"
        cols="12"
        sm="6"
        md="4"
      >
        <v-card dark>
          <div>
            <v-card-title class="headline">
              {{ base.name }}
              <v-spacer></v-spacer>
              <v-btn icon @click="deleteBase(base)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-card-title>

            <v-img
              v-if="base.screenshotURL"
              height="200"
              :src="base.screenshotURL"
              @click="selectedScreenshotURL = base.screenshotURL;showScreenshot = true;"
            ></v-img>
            <v-col cols="12" style="text-align: right;">
              <!--              v-if="changeImage === index || !base.screenshotURL"-->
              <v-file-input
                accept="image/jpeg"
                placeholder="Choose New Image..."
                prepend-icon="mdi-camera"
                label="Base Image"
                type="file"
                v-model="base.file"
                @change="filesChange(base);"
                hide-details
              ></v-file-input>
            </v-col>

            <v-card-text>
              <v-select label="Difficulty" :items="difficulties" v-model="base.difficulty" @change="save(base)"/>
              <v-row>
                <v-col cols="4" class="ma-0 py-0">
                  <v-checkbox v-model="base.autoheight" label="Autoheight" @change="save(base)" hide-details/>
                </v-col>
                <v-col cols="4" class="ma-0 py-0">
                  <v-checkbox v-model="base.stability" label="Stabilty" @change="save(base)" hide-details/>
                </v-col>
                <v-col cols="4" class="ma-0 py-0">
                  <v-text-field label="Height" type="number" v-model="base.height" @click="save(base)"
                                @change="save(base)" hide-details/>
                </v-col>
              </v-row>
              <v-row class="my-2 pa-0">
                <strong>Days of wipe:</strong>
              </v-row>
              <v-row>
                <v-col style="text-align-last: center;" class="ma-0 pa-0">
                  <v-btn-toggle
                    color="green"
                    v-model="base.daysOfWipe"
                    multiple
                    @change="save(base)"
                  >
                    <v-btn v-for="day in days" :key="day">
                      {{ day }}
                    </v-btn>
                  </v-btn-toggle>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-checkbox label="Autospawn Enabled" v-model="base.enabled" @change="save(base)"></v-checkbox>
              <v-spacer></v-spacer>
              <v-chip light small v-if="base.difficulty" :color="colors[base.difficulty]">{{base.difficulty}}</v-chip>
            </v-card-actions>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="showScreenshot">
      <v-img
        :src="selectedScreenshotURL"
        height="80vh"
        @click="showScreenshot = false"
      ></v-img>
    </v-dialog>
  </v-container>
</template>

<script>
  // import VueApexCharts from "vue-apexcharts";

  import {mapGetters} from "vuex";
  import AppBar from "@/components/AppBar";
  import moment from "moment";

  export default {
    components: {AppBar},
    computed: {
      ...mapGetters(["currentUser", "bases", "basesLoading"]),
      basesPage() {
        return this.basesFiltered.slice(((this.page - 1) * this.pageSize), (this.pageSize * this.page));
      },
      basesFiltered() {
        let filteredBases = this.bases;
        if (this.baseSearch !== "") {
          filteredBases = filteredBases.filter(b => {
            return b.name.toUpperCase().indexOf(this.baseSearch.toUpperCase()) > -1;
          })
        }
        if (this.filter) {
          if (this.filter.hasOwnProperty("difficulty") && this.filter.difficulty) {
            filteredBases = filteredBases.filter(b => {
              return b.difficulty.toUpperCase() == this.filter.difficulty.toUpperCase();
            })
          }
          if (this.filter.autospawnEnabled == true) {
            filteredBases = filteredBases.filter(b => {
              return b.enabled == this.filter.autospawnEnabled;
            })
          }
          if (this.filter.daysOfWipe && this.filter.daysOfWipe.length > 0) {
            filteredBases = filteredBases.filter(b => {
              return b.daysOfWipe.filter(value => this.filter.daysOfWipe.includes(value)).length > 0;
            })
          }
        }

        return filteredBases;
      }
    },
    props: {
      source: String,
    },
    data: () => ({
      filter: {
        dayOfWipe: [],
        difficulty: null,
        autospawnEnabled: false
      },
      expanded: true,
      selectedScreenshotURL: "",
      showScreenshot: false,
      changeImage: -1,
      files: [],
      colors: {
        "Easy": "#5fc25f",
        "Medium": "#cbcb61",
        "Hard": "#aa5e5e",
        "Expert": "#28289c",
        "Nightmare": "#383232"
      },
      difficulties: ['Easy', 'Medium', 'Hard', 'Expert', 'Nightmare'],
      days: ['1', '2', '3', '4', '5'],
      baseSearch: "",
      baseSearchInput: "",
      page: 1,
      pageSize: 30,
      saving: false,
      searchDebounce: null,
    }),
    mounted() {
      this.$store.dispatch("loadBases");
    },
    methods: {
      clearFilter() {
        console.log(this.filter);
        this.filter.dayOfWipe = [];
        this.filter.difficulty = null;
        this.filter.autospawnEnabled = false;
      },
      onSearchChange() {
        clearTimeout(this.searchDebounce);
        this.searchDebounce = setTimeout(() => {
          this.page = 1;
          this.baseSearch = this.baseSearchInput
        }, 500);
        requestAnimationFrame(x);
      },
      filesChange(base) {
        let formData = new FormData();

        formData.append("file", base.file);
        delete base.file;
        formData.append("id", base.id);

        this.$store.dispatch("saveBaseImage", formData).then(() => {
          this.saving = false;
          this.changeImage = -1;
          this.$store.dispatch("loadBases");
        });
      },
      deleteBase(base) {
        this.$swal({
          title: 'Are you sure you want to delete this base?',
          showCancelButton: true,
          confirmButtonText: `Delete`,
        }).then((result) => {
          console.log(result);
          /* Read more about isConfirmed, isDenied below */
          if (result.value == true) {
            this.saving = true;
            this.$store.dispatch("deleteBase", base).then(() => {
              this.saving = false;
              this.$store.dispatch("loadBases");
            });
          }
        })
      },
      save(base) {
        console.log(base);
        this.saving = true;
        this.$store.dispatch("saveBase", base).then(() => {
          this.saving = false;
          this.$store.dispatch("loadBases");
        });
      },
    },
  };
</script>
